import { createFileRoute } from '@tanstack/react-router'

import { accountAdminApi } from '@/features/account'
import { AccountFormPage } from '@/features/account/components/account-form-page'

export const Route = createFileRoute('/_app/settings/user/$id/edit')({
  loader: async ({ params, context }) => {
    const { id } = params
    const {
      data: { account },
    } = await context.qc.ensureQueryData(accountAdminApi.detail.query({ params: { id } }))

    return {
      crumb: account.name,
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const navigate = Route.useNavigate()

  return (
    <AccountFormPage
      mode='update'
      id={id}
      onBack={() => navigate({ to: '/settings/user', replace: true })}
    />
  )
}
